import React from 'react';
import './ICBanner.css';

function ICBanner(props) {
    const { bannerText } = props;
    return (
        <div className="ICIntegrationBanner">
            <h3>{bannerText}</h3>
        </div>
    );
}

export default ICBanner;